import { UtilF } from '../../../../../../modules/Util/F/Function/module/UtilF.js';

window._en = ENV.lang == 'kr' ? '' : `_${ENV.lang}`;
window._collabo = collabo_type == '' ? '' : `_${collabo_type}`;

const [{ default: mpe_translator }, { translator }, { default: omp_translator }] = await Promise.all([
  import('../../../../../../modules/MShop/Translation/i18n.config.js'),
  import('../../../../sh/app/all/i18next.config.js'),
  import('../../../../../../modules/OMP/Core/Translation/omp_i18next.config.js'),
]);

const [ET, T, TT] = await Promise.all([
  mpe_translator.changeLanguage(ENV.lang),
  translator.changeLanguage(ENV.lang),
  omp_translator.changeLanguage(ENV.lang),
]);

window.ET = ET;
window.ET.lang = ENV.lang;
window.lang = mpe_translator.language;

window.T = T;
window.T.lang = ENV.lang;

window.TT = TT;
window.TT.lang = ENV.lang;

if (!window.box) {
  window.box = _p.box(ENV.box);
  delete ENV.box;
}
const marpple_blazy = new Blazy({
  selector: '.don_lazy',
  offset: $.innerHeight(window),
});
G.don_lazy = function () {
  marpple_blazy.revalidate();
};

UtilF.initBackForward(() => {
  G.don_lazy();
});

const lang_regex = new RegExp(
  '^javascript:|^/$|^http:|^https:|^mailto:|^tel:|^#|^//|' +
    _p
      .map(window.box.sel('langs'), function (lang) {
        return '^/' + lang;
      })
      .join('|'),
);
G.add_lang = function (el) {
  _p.each($.find(el, 'a[href]:not(.external-url)'), function (anchor) {
    const href = anchor.getAttribute('href');
    if (!lang_regex.test(href)) anchor.setAttribute('href', '/' + ENV.lang + href);
  });
};
G.add_lang($('body'));

window.fbAsyncInit = function () {
  FB.init({
    appId: ENV.appId,
    xfbml: true,
    version: 'v8.0',
  });
  FB.AppEvents.logPageView();
};

(function (d, s, id) {
  const fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  const js = d.createElement(s);
  js.id = id;
  js.src = 'https://connect.facebook.net/en_US/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');
